var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyPreferences = function SvgMyPreferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 6H2v1h11zM22 6h-2v1h2zM4 11.5H2v1h2zM22 11.5H11v1h11zM13 17H2v1h11zM22 17h-2v1h2zM16.5 5c.827 0 1.5.673 1.5 1.5S17.327 8 16.5 8 15 7.327 15 6.5 15.673 5 16.5 5m0-1a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5M16.5 16c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5m0-1a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5M7.5 10.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5S6 12.827 6 12s.673-1.5 1.5-1.5m0-1a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5"
  })));
};
export default SvgMyPreferences;